var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinimalize = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.795 6.19497C19.0683 5.92161 19.0683 5.47839 18.795 5.20503C18.5216 4.93166 18.0784 4.93166 17.805 5.20503L14.8 8.21005L14.8 7.1C14.8 6.7134 14.4866 6.4 14.1 6.4C13.7134 6.4 13.4 6.7134 13.4 7.1L13.4 9.9C13.4 10.2866 13.7134 10.6 14.1 10.6L16.9 10.6C17.2866 10.6 17.6 10.2866 17.6 9.9C17.6 9.5134 17.2866 9.2 16.9 9.2H15.7899L18.795 6.19497ZM5.20503 18.795C4.93166 18.5216 4.93166 18.0784 5.20503 17.805L8.21005 14.8H7.1C6.7134 14.8 6.4 14.4866 6.4 14.1C6.4 13.7134 6.7134 13.4 7.1 13.4H9.9C10.2866 13.4 10.6 13.7134 10.6 14.1L10.6 16.9C10.6 17.2866 10.2866 17.6 9.9 17.6C9.5134 17.6 9.2 17.2866 9.2 16.9L9.2 15.79L6.19497 18.795C5.92161 19.0683 5.47839 19.0683 5.20503 18.795Z",
    fill: "#494C5B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinimalize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/minimalize.ad63eea092e5311ae0d2b55cb094e7bd.svg";